import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import { strings, getCurrentLocale } from '../../../localization';

export default class AccountDropdown extends PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            active: false
        }
    }

    componentDidMount() {

        window.addEventListener('click', this.onBlur)
    }

    componentWillUnmount() {

        window.removeEventListener('click', this.onBlur);
    }

    toggleActive = (e) => {

        this.setState({
            active: !this.state.active
        })
    }

    onBlur = (e) => {

        if (e.target != this.ref && e.target.parentElement != this.ref)
            this.setState({
                active: false
            })
    }

    render() {

        var btnClasses = [
            'btn-account',
            'btn-dropdown'
        ]

        if (this.state.active) btnClasses.push('active');

        return (
            <span>
                <a className={btnClasses.join(' ')}
                    onClick={this.toggleActive}
                    onBlur={this.onBlur}
                    ref={ref => { this.ref = ref; }}
                >
                    {strings.formatString(strings.account)}<i className="material-icons">account_circle</i>
                </a>
                <span>
                    <label>{strings.formatString(strings.signed_in_as)}</label>
                    <h4>{this.props.user.email}</h4>
                    <a className="btn-logout" onClick={this.props.onLogout}>{strings.formatString(strings.sign_out_title)}</a>
                    <NavLink to={'/' + getCurrentLocale() + '/account/profile'} className="btn btn-go-to-account">{strings.formatString(strings.go_to_account)}</NavLink>
                </span>
            </span>
        )
    }
}
